import i18next from 'i18next';

export const createPageTitle = (...params: any[]) =>
  (params || [])
    .filter((param) => !!param)
    .concat([i18next.t('brandName', { ns: 'global' })])
    .join(' | ');
